//Spinner qui apparaît lorsqu'un élément charge

import React from "react";

export default function Loading() {
  return (
    <div className="spinner-container">
      <div className="spinner"></div>
    </div>
  );
}
